module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/white_ant_check_code.e066987.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/code/white_ant_check_code.jpg
// module id = NFcf
// module chunks = 3